import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Api_Url } from "../../../config/config";
import axios from "axios";
import { Form, Input, Table, Button, Popconfirm } from "antd";
import { ErrorToast, InfoToast } from "../../ToastComponent";

function CashFlowDataSinglePage() {
  const location = useLocation();
  const { state } = location;

  console.log("state",state.CustomerData.id)

  const [buisnessPdId, setBuisnessPdId] = useState(Number);
  const [income, setIncome] = useState("");
  const [cashflowData, setCashflowData] = useState([]);
  const [household, setHousehold] = useState(0);
  const [allData, setAllData] = useState({
    businessPdId: 0,
    income: 0,
    pdCashFlows: "",
    householdExpenses: 0,
    latitude: "",
    longitude: "",
  });

  console.log(buisnessPdId)

  console.log(income);

  useEffect(() => {
    setBuisnessPdId(state?.CustomerData?.id || "");
    setIncome(state?.CustomerData?.totalIncome || "");
  }, [state]);


  const fetchCashData = async (household = 0) => {
    try {
      const response = await axios.get(
        `${Api_Url}api/v1/BusinessPd/cashflow/${buisnessPdId}/${income}/${household}`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user"))?.accessToken
            }`,
          },
        }
      );
      setCashflowData(response.data.data);
    } catch (error) {
      console.log("Error: ", error);
    }
  };
  

  // const fetchCashData = async (household = 0) => {
  //   try {
  //     const response = await axios.get(
  //       `${Api_Url}api/v1/BusinessPd/cashflow/${buisnessPdId}/${income}/${household}`,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${
  //             JSON.parse(sessionStorage.getItem("user"))?.accessToken
  //           }`,
  //         },
  //       }
  //     );
  //     console.log("helo", response.data.data);
  //     setCashflowData(response.data.data);
  //   } catch (error) {
  //     console.log("Error: ", error);
  //   }
  // };

  console.log("first", cashflowData);

  useEffect(() => {
    if (buisnessPdId && income) {
      fetchCashData(household);
    }
  }, [buisnessPdId, income, household]);

  useEffect(() => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        const { latitude, longitude } = position.coords;
        setAllData((prevData) => ({
          ...prevData,
          latitude: latitude.toString(),
          longitude: longitude.toString(),
          pdCashFlows: cashflowData || [],
        }));
      });
    } else {
      console.log("Geolocation is not supported by this browser.");
    }
  }, [cashflowData]);


  const handleClick = async () => {
    const updatedAllData = {
      ...allData,
      businessPdId: buisnessPdId,
      income: income,
    };
    try {
      const response = await axios.post(
        `${Api_Url}api/v1/PdCashFlow`,
        updatedAllData,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user"))?.accessToken
            }`,
          },
        }
      );
      setCashflowData([])
      fetchCashData();
      InfoToast("casflow Added")
  
      // if (response.data.succeeded) {
      //   InfoToast(response.data.message);
      // }
    } catch (error) {
      ErrorToast("Something went wrong");
    }
  };
  

  // const handleClick = async () => {
  //   // Ensure allData is updated with the latest buisnessPdId and income
  //   const updatedAllData = {
  //     ...allData,
  //     businessPdId: buisnessPdId,
  //     income: income,
  //   };
  
  //   try {
  //     const response = await axios.post(
  //       `${Api_Url}api/v1/PdCashFlow`,
  //       updatedAllData,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${
  //             JSON.parse(sessionStorage.getItem("user"))?.accessToken
  //           }`,
  //         },
  //       }
  //     );
  //     console.log("response", response.data);
  //     if (response.data.succeeded) {
  //       InfoToast(response.data.message);
  //       fetchCashData();
  //     }
  //   } catch (error) {
  //     ErrorToast("Something went wrong");
  //   }
  // };


  const handleDeleteAll = async () => {
    try {
      await axios.delete(`${Api_Url}api/v1/PdCashFlow/${cashflowData[0]?.id}`, {
        headers: {
          Authorization: `Bearer ${
            JSON.parse(sessionStorage.getItem("user"))?.accessToken
          }`,
        },
      });
      setCashflowData([]);
      fetchCashData();
      InfoToast("All cash flows deleted");
      
    } catch (error) {
      ErrorToast("Something went wrong");
      console.log("Error: ", error);
    }
  };
  
  

  // const handleDeleteAll = async () => {
  //   console.log(cashflowData)
  //   try {
  //     await axios.delete(`${Api_Url}api/v1/PdCashFlow/${cashflowData[0]?.id}`, {
  //       headers: {
  //         Authorization: `Bearer ${
  //           JSON.parse(sessionStorage.getItem("user"))?.accessToken
  //         }`,
  //       },
  //     });
  //     setCashflowData([]);
  //     InfoToast("All cash flows deleted");
  //   } catch (error) {
  //     ErrorToast("Something went wrong");
  //     console.log("Error: ", error);
  //   }finally{
  //     fetchCashData();
  //   }
  // };

  const EditableContext = React.createContext(null);

  const EditableRow = ({ index, ...props }) => {
    const [form] = Form.useForm();
    return (
      <Form form={form} component={false}>
        <EditableContext.Provider value={form}>
          <tr {...props} />
        </EditableContext.Provider>
      </Form>
    );
  };

  const EditableCell = ({
    title,
    editable,
    children,
    dataIndex,
    record,
    handleSave,
    ...restProps
  }) => {
    const [editing, setEditing] = useState(false);
    const inputRef = React.useRef(null);
    const form = React.useContext(EditableContext);

    useEffect(() => {
      if (editing) {
        inputRef.current.focus();
      }
    }, [editing]);

    const toggleEdit = () => {
      setEditing(!editing);
      form.setFieldsValue({ [dataIndex]: record[dataIndex] });
    };

    const save = async () => {
      try {
        const values = await form.validateFields();
        handleSave({ ...record, ...values });
        setEditing(false);
      } catch (errInfo) {
        console.log("Save failed:", errInfo);
      }
    };

    let childNode = children;

    if (editable) {
      childNode = editing ? (
        <Form.Item
          style={{ margin: 0 }}
          name={dataIndex}
          rules={[
            {
              required: true,
              message: `${title} is required.`,
            },
          ]}
        >
          <Input
            ref={inputRef}
            onPressEnter={save}
            onBlur={save}
            onKeyDown={(e) => {
              if (e.key === "Escape") {
                setEditing(false);
              }
            }}
          />
        </Form.Item>
      ) : (
        <div className="editable-cell-value-wrap" onClick={toggleEdit}>
          {children}
        </div>
      );
    }

    return <td {...restProps}>{childNode}</td>;
  };

const handleSave = (row) => {
  const newData = [...cashflowData];
  
  const index = newData.findIndex((item) => row.id === item.id);
  
  if (index > -1) {
    const item = newData[index];
    const updatedEmiValue = row.emiValue;
    const updatedSurplus = item.income - item.hhValue - updatedEmiValue;

    newData.splice(index, 1, { ...item, ...row, surplus: updatedSurplus });
    setCashflowData(newData);
  } else {
    console.error("Attempted to save an unknown row:", row);
  }
};

  

  const calculateNetSurplus = (data) => {
    return data.reduce((acc, item) => acc + item.surplus, 0).toFixed(3);
  };

  const columns = [
    {
      title: "Year",
      dataIndex: "year",
    },
    {
      title: "Income",
      dataIndex: "income",
      render: (text) => Number(text).toFixed(3),
    },
    {
      title: "HHE-Annual",
      dataIndex: "hhValue",
    },
    {
      title: "EMI Annual",
      dataIndex: "emiValue",
      editable: true,
    },
    {
      title: "Surplus",
      dataIndex: "surplus",
      render: (text) => Number(text).toFixed(3),
    },
  ];

  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }

    return {
      ...col,
      onCell: (record) => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave: handleSave,
      }),
    };
  });

  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
        <div className="container mt-3">
          <div className="row mt-4">
            <div className="col-12">
              <div className="input-block mb-3">
                <label className="col-form-label">Enter Household Value</label>
                <input
                  type="number"
                  placeholder="Enter House Hold Value"
                  className="form-control"
                  value={household}
                  onChange={(event) => setHousehold(event.target.value)}
                />
              </div>
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-12 mx-auto">
              <Table
                className="table-striped"
                style={{ overflowX: "auto" }}
                components={{
                  body: {
                    row: EditableRow,
                    cell: EditableCell,
                  },
                }}
                columns={[
                  ...mergedColumns,
                  {
                    title: (
                      <Popconfirm
                        title="Are you sure you want to delete all data?"
                        onConfirm={handleDeleteAll}
                        okText="Yes"
                        cancelText="No"
                      >
                        <Button danger>Delete All</Button>
                      </Popconfirm>
                    ),
                    dataIndex: "delete",
                    render: () => null,
                  },
                ]}
                dataSource={cashflowData}
                rowKey={(record) => record.id}
              />
              <div className="d-flex align-items-center justify-content-between px-5">
                <p className="fw-bold mb-0" style={{ fontSize: "18px" }}>
                  Net Surplus:
                </p>
                <span
                  className="mb-0 fw-bold text-success"
                  style={{ fontSize: "16px" }}
                >
                  &#8377; {calculateNetSurplus(cashflowData)}
                </span>
              </div>
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-12">
              <button className="btn add-btn me-auto ms-2" onClick={handleClick}>
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CashFlowDataSinglePage;
